import mapActions from './mapActions';

export default mapActions('reward_multipliers', {
	fetchAll_url: () => '/api/rewards/multipliers',
	create_url: () => '/api/rewards/multipliers'
});